import { FC } from 'react';
import {
  Flex,
  FlexProps,
  useMultiStyleConfig,
  Box,
  Text,
  Button,
  Center,
} from '@chakra-ui/react';

export interface ChakraSelectionCardProps extends FlexProps {
  icon: React.ReactElement;
  heading: string;
  text: string;
  actionText: string;
  onClick: () => void;
}

export const ChakraSelectionCard: FC<ChakraSelectionCardProps> = ({
  icon,
  heading,
  text,
  actionText,
  onClick,
  ...rest
}) => {
  const styles = useMultiStyleConfig('SelectionCard', {});
  return (
    <Flex
      tabIndex={0}
      role="button"
      onClick={onClick}
      sx={styles.container}
      {...rest}
    >
      <Box sx={styles.header}>
        <Center sx={styles.icon} data-testid="selection-card-icon">
          {icon}
        </Center>
        <Text
          fontSize="lg"
          fontWeight={500}
          data-testid="selection-card-heading"
        >
          {heading}
        </Text>
      </Box>
      <Text fontSize="xs" color="textSubdued" data-testid="selection-card-text">
        {text}
      </Text>
      <Button
        pointerEvents="none"
        mt={6}
        tabIndex={-1}
        data-testid="selection-card-button"
      >
        {actionText}
      </Button>
    </Flex>
  );
};
